export default {
    loading: 'loading',
    signedOut: 'signedOut',
    loggedIn: 'loggedIn'
};
